import copy from './copy.json';
import {
  ATTACHMENT_COUNT_LIMIT,
  ATTACHMENT_FILE_LIMIT,
  ATTACHMENT_TOTAL_LIMIT,
} from './nativeModel';
export const translate = (locale, key, vars = {}) =>
  String(copy[locale === 'en' ? 'en' : 'ko'][key] || key).replace(
    /\{\{(\w+)\}\}/g,
    (_, k) => vars[k] ?? '',
  );
export function validateContact(form, t) {
  const errors = {};
  if (!form.name.trim()) errors.name = t('contact.nameRequired');
  if (!form.email.trim()) errors.email = t('contact.emailRequired');
  else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email.trim()))
    errors.email = t('contact.emailInvalid');
  if ((form.middle || form.last) && (form.middle.length < 3 || form.last.length !== 4))
    errors.telephone = t('contact.phoneInvalid');
  if (!form.message.trim()) errors.message = t('contact.messageRequired');
  return errors;
}
export function phoneMiddle(raw, prefix) {
  let digits = raw.replace(/\D/g, '');
  if (digits.startsWith(prefix) && digits.length > prefix.length + 4)
    digits = digits.slice(prefix.length);
  return digits.length > 4
    ? { middle: digits.slice(0, -4).slice(0, 4), last: digits.slice(-4), focus: true }
    : { middle: digits.slice(0, 4), focus: digits.length === 4 };
}
export function addFiles(existing, selected, t) {
  if (existing.length >= ATTACHMENT_COUNT_LIMIT)
    return { files: existing, error: t('contact.attachmentLimit', { count: 3 }) };
  if (
    selected.some(
      (f) =>
        !/^(application\/pdf|image\/(jpeg|png|webp|heic|heif))$/.test(
          (f.type || '').split(';')[0].trim().toLowerCase(),
        ) && !/\.(pdf|jpe?g|png|webp|heic|heif)$/i.test(f.name),
    )
  )
    return {
      files: existing,
      error: t('contact.attachmentMeta') + ' (JPG, PNG, WebP, HEIC, HEIF, PDF)',
    };
  if (selected.some((f) => f.size > ATTACHMENT_FILE_LIMIT))
    return { files: existing, error: t('contact.fileTooLargeOne') };
  const files = [...existing, ...selected].slice(0, ATTACHMENT_COUNT_LIMIT);
  if (files.reduce((n, f) => n + f.size, 0) > ATTACHMENT_TOTAL_LIMIT)
    return { files: existing, error: t('contact.fileTooLargeTotal') };
  return {
    files,
    error:
      existing.length + selected.length > 3 ? t('contact.attachmentAddedLimit', { count: 3 }) : '',
  };
}
export function contactPayload(form) {
  return {
    name: form.name.trim(),
    email: form.email.trim(),
    message: form.message.trim(),
    ...(form.middle || form.last
      ? { telephone: `${form.prefix}-${form.middle}-${form.last}` }
      : {}),
  };
}
